import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useFeatureValue } from "@growthbook/growthbook-react";

import { FEATURE_FLAGS, CATEGORY_REDESIGN_HALLOWEEN_VARIANTS } from "enums/growthbook";

const HALLOWEEN_CATEGORY_PATH = "/browse/halloween-ecards";

const useScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export const useScrollToTopOnPathnameChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const useScrollToTopOnNewCategory = () => {
  const birthdayCategoryPage = useFeatureValue(
    FEATURE_FLAGS.CATEGORY_REDESIGN_HALLOWEEN,
    CATEGORY_REDESIGN_HALLOWEEN_VARIANTS.BASELINE,
  );
  const isBirthdayCategoryNewPage =
    birthdayCategoryPage === CATEGORY_REDESIGN_HALLOWEEN_VARIANTS.NEW_CATEGORY_DESIGN_HALLOWEEN;
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === HALLOWEEN_CATEGORY_PATH && isBirthdayCategoryNewPage) {
      const originalScrollRestoration = window.history.scrollRestoration;

      if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

      requestAnimationFrame(() => {
        window.scrollTo(0, 0);
      });

      return () => {
        if ("scrollRestoration" in window.history) window.history.scrollRestoration = originalScrollRestoration;
      };
    }
    return () => {};
  }, [pathname, isBirthdayCategoryNewPage]);
};

export default useScrollToTop;
